import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Text, VStack } from "native-base";
import styles from "./styles.module.css";
import Modal from "../modal";
import colors from "../../constants/colors";

function BankAccountModal(props) {
  const { isOpen, onRequestClose } = props;
  const [bankAccount, setBankAccount] = useState(props.bankAccount);

  useEffect(() => {
    if (isOpen) {
      setBankAccount(props.bankAccount);
    }
  }, [isOpen, props.bankAccount]);

  return (
    <Modal maxWidth={700} isOpen={isOpen} onRequestClose={onRequestClose}>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          onRequestClose();
          props.setBankAccount(bankAccount);
        }}>
        <VStack padding={10} space={5}>
          <Text bold color={colors.primary} textAlign="center" fontSize="xl">
            Ingresa los datos de tu cuenta
          </Text>
          <label className={styles.input}>
            <Text>Nombre del beneficiario</Text>
            <input
              type="text"
              required
              value={bankAccount?.holder || ""}
              onChange={(e) =>
                setBankAccount({ ...bankAccount, holder: e.target.value })
              }
            />
          </label>
          <Text bold fontSize="lg">
            Número de cuenta
          </Text>
          <label className={styles.input}>
            <Text>Clave</Text>
            <input
              type="text"
              required
              value={bankAccount?.clave || ""}
              onChange={(e) =>
                setBankAccount({ ...bankAccount, clave: e.target.value })
              }
            />
          </label>
          <label className={styles.input}>
            <Text>Interbancaria</Text>
            <input
              type="text"
              required
              value={bankAccount?.interbancaria || ""}
              onChange={(e) =>
                setBankAccount({
                  ...bankAccount,
                  interbancaria: e.target.value,
                })
              }
            />
          </label>
          <label className={styles.input}>
            <Text>Nombre del banco</Text>
            <input
              type="text"
              required
              value={bankAccount?.bankName || ""}
              onChange={(e) =>
                setBankAccount({ ...bankAccount, bankName: e.target.value })
              }
            />
          </label>
          <button>
            <Box
              backgroundColor={colors.primary}
              paddingY={3}
              paddingX={100}
              borderRadius="full">
              <Text color={colors.white}>Guardar y Continuar</Text>
            </Box>
          </button>
        </VStack>
      </form>
    </Modal>
  );
}

BankAccountModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  bankAccount: PropTypes.object.isRequired,
  setBankAccount: PropTypes.func.isRequired,
};

export default BankAccountModal;
